import styled from 'styled-components'

interface IStyleProps {
  modal?: boolean
  small?: boolean
}

export default styled.div`
  z-index: ${(props: IStyleProps) => {
    if (props.modal) return ''
    return 205
  }};
  width: ${(props: IStyleProps) => {
    if (props.modal) return '100%'
    return '100%'
  }};
  height: ${(props: IStyleProps) => {
    if (props.modal) return '100%'
    return '100%'
  }};
  position: ${(props: IStyleProps) => {
    if (props.modal) return 'relative'
    return 'fixed'
  }};
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: none;

  @keyframes load {
    to {
      transform: rotate(360deg);
    }
  }
  .loading-img {
    width: ${(props: IStyleProps) => {
      if (props.small) return '40px'
      return '80px'
    }};
    height: ${(props: IStyleProps) => {
      if (props.small) return '40px'
      return '80px'
    }};

    animation: load 2s infinite linear;
  }
`
